import { useQuery } from 'react-query';

import { getLogicCheckerCategoryResults as queryFn } from 'api/endPoints/getLogicCheckerCategoryResults';

import {
    IAssignee,
    IStatus,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryGetLogicCheckerCategoryResults = (params) => {
    return useQuery<ILogicCheckerCategoryResultsResponse, QueryError>(
        ['getLogicCheckerCategoryResults', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.fileMetaDataId),
        },
    );
};

export interface ILogicCheckerCategoryResultsResponse {
    categoriesSummaryHeaders: {
        accessor: string;
        clickable: boolean;
        colorable: boolean;
        header: string;
        order: number;
        sortable: string;
    }[];
    categoriesSummaryRows: {
        category: string;
        complianceColor: string;
        compliantActivities: number;
        compliantActivitiesPersent: string;
        nonCompliantActivities: number;
        nonCompliantActivitiesPersent: string;
        scoreImpact: number;
        validationHeaders: {
            accessor: string;
            clickable: boolean;
            colorable: boolean;
            header: string;
            order: number;
            sortable: string;
        }[];
        validationRows: {
            complianceColor: string;
            compliantActivities: number;
            compliantActivitiesPersent: string;
            nonCompliantActivities: number;
            nonCompliantActivitiesPersent: string;
            scoreImpact: number;
            validationId: number;
            validationName: string;
            dcma: boolean;
            mandatory: boolean;
            status: 'PASS' | 'FAIL';
            associatedCard: {
                cardId: null | number;
                status: IStatus;
                assignee: IAssignee;
            };
        }[];
    }[];
    title: string;
}
